export const ADMIN_PERMISSION = 'admin';

export function hasPermission(permissions, requiredPermission) {
  if (requiredPermission === 'dashboard') return true;
  if (!Array.isArray(permissions)) return false;
  return (
    permissions.includes(ADMIN_PERMISSION) ||
    permissions.includes(requiredPermission)
  );
}

export function normalizePermissions(permissions) {
  if (!Array.isArray(permissions)) return [];
  const uniquePermissions = [
    ...new Set(
      permissions.filter(
        (permission) =>
          permission !== 'user_internal' && permission !== 'category'
      )
    ),
  ];
  return uniquePermissions.includes(ADMIN_PERMISSION)
    ? [ADMIN_PERMISSION]
    : uniquePermissions;
}
